import {useEffect, useState} from 'react';
import {itemsApi} from '@/api/items';

/**
A blob URL for one of our preserved images (`/api/images/{sha256}`), or null while loading, on
failure, or when `sha256` is unset. No query client: `Thumbnail` renders everywhere, and the API
marks these responses immutable, so the browser's HTTP cache already answers a repeat request.
*/
export function useStoredImageUrl(
  sha256: string | null | undefined,
  fetchImage: (sha256: string) => Promise<Blob> = itemsApi.storedImage
): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!sha256) {
      setUrl(null);
      return;
    }

    let objectUrl: string | undefined;
    let cancelled = false;
    fetchImage(sha256)
      .then((blob) => {
        if (!cancelled) {
          objectUrl = URL.createObjectURL(blob);
          setUrl(objectUrl);
        }
      })
      .catch(() => {
        setUrl(null);
      });
    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [sha256, fetchImage]);

  return url;
}
